import { apiSlice } from "./apiSlice";
import { updatePromosParams, setPromos, setPromosSelection } from "../slice/promoSlice";

export const promoApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getPromos: builder.query({
      query: params => (params ? `/api/pricing/v1/promo/?${params}` : "/api/pricing/v1/promo/"),
      onQueryStarted: (params, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => {
            dispatch(setPromos(result.data));
            if (result.data.limit) {
              dispatch(updatePromosParams({ limit: result.data.limit }));
            }
          })
          .catch(error => {});
      },
      providesTags: ["promoList"],
    }),
    getPromosSelection: builder.query({
      query: () => `/api/pricing/v1/promo/selection`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setPromosSelection(result.data))).catch(error => {});
      },
    }),
    getPromo: builder.query({
      query: id => `/api/pricing/v1/promo/${id}/`,
      providesTags: (result, error, id) => [{ type: "promo", id }],
    }),
    addPromo: builder.mutation({
      query: data => ({
        url: "/api/pricing/v1/promo/",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["promoList"],
    }),
    updatePromo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api/pricing/v1/promo/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => ["promoList", { type: "promo", id }],
    }),
    deletePromo: builder.mutation({
      query: id => ({
        url: `/api/pricing/v1/promo/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["promoList"],
    }),
    activatePromo: builder.mutation({
      query: id => ({
        url: `/api/pricing/v1/promo/${id}/activate/`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => ["promoList", { type: "promo", id }],
    }),
    deactivatePromo: builder.mutation({
      query: id => ({
        url: `/api/pricing/v1/promo/${id}/deactivate/`,
        method: "POST",
      }),
      invalidatesTags: (result, error, id) => ["promoList", { type: "promo", id }],
    }),
  }),
});

export const {
  useGetPromosQuery,
  useGetPromoQuery,
  useAddPromoMutation,
  useUpdatePromoMutation,
  useDeletePromoMutation,
  useActivatePromoMutation,
  useDeactivatePromoMutation,
  useLazyGetPromosSelectionQuery,
} = promoApiSlice;
